import React from "react"

import { TextStyle, TextStyleProps } from "@silversea-ssc/ui-components-react"
import BlockContent, { BlockContentProps } from "../BlockContent/BlockContent"

interface TextBoxProps extends TextStyleProps {
    content: BlockContentProps["value"]
    tokens?: BlockContentProps["tokens"]
}

const TextBox: React.FC<React.PropsWithChildren<TextBoxProps>> = ({ content, tokens, ...textContainerProps }) => {
    return (
        <TextStyle {...textContainerProps}>
            <BlockContent value={content} tokens={tokens} />
        </TextStyle>
    )
}

export default TextBox
